import { render, staticRenderFns } from "./list_ads.vue?vue&type=template&id=b62b700e&scoped=true"
import script from "./list_ads.vue?vue&type=script&lang=js"
export * from "./list_ads.vue?vue&type=script&lang=js"
import style0 from "./list_ads.vue?vue&type=style&index=0&id=b62b700e&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b62b700e",
  null
  
)

export default component.exports